import { getZones } from 'api/zones/endpoints/getZones';
import type { Zone } from 'api/zones/endpoints/postZone';

/**
 * Load one zone by name for the edit form. The backend has no single-zone GET,
 * so this queries the (boundary-validated) list with the name filter and
 * exact-matches the result. The list filter is a substring `ILIKE` (and `_` is a
 * SQL wildcard), so the narrowed page can hold near-matches — hence a generous
 * limit so the exact match can't sort past the default 50-row page, plus the
 * exact `find`. Works even when the list slice isn't populated (e.g. the
 * Workspace). Returns null if not found, so the caller can surface a "not found"
 * instead of opening the dialog on a missing record.
 */
export const loadZone = async (name: string): Promise<Zone | null> => {
  const page = await getZones({ name, limit: 2000 });
  return page.zones.find((zone) => zone.name === name) ?? null;
};
